import { render, staticRenderFns } from "./playerOrderofMerit.vue?vue&type=template&id=30385432&scoped=true"
import script from "./playerOrderofMerit.vue?vue&type=script&lang=js"
export * from "./playerOrderofMerit.vue?vue&type=script&lang=js"
import style0 from "./playerOrderofMerit.vue?vue&type=style&index=0&id=30385432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30385432",
  null
  
)

export default component.exports